export enum DeviceAlertsModalTab {
  BasicConfiguration = 'basic',
  Configuration = 'configuration',
  NotificationsConfiguration = 'notifications',
}
